
 const FOOTER_DATA = {
  "bottom_footer": [
      {
          "className": "text-uppercase",
          "link": "http://www.airtelmoney.mw/contact-us",
          "target": "",
          "name": "Contact Us",
          "translatedName": "Contact Us",
          "i18": "Contact_Us",
          "click": "",
          "image": ""
      },
      {
          "className": "text-uppercase",
          "link": "http://www.airtelmoney.mw/copyRightPrivacy",
          "target": "",
          "name": "Copyright and Privacy Notice",
          "translatedName": "Copyright and Privacy Notice",
          "i18": "privacy_policy",
          "click": "",
          "image": ""
      },
     
      {
          "className": "text-uppercase",
          "link": "airtelmoney.mw/Terms-and-Conditions",
          "target": "",
          "name": "Terms and Conditions",
          "translatedName": "Terms and Conditions",
          "i18": "Terms_Conditions",
          "click": "",
          "image": ""
      }
  ],
  "social_media": [
      {
          "className": "text-uppercase",
          "link": "https://www.instagram.com/airtel_malawi/",
          "target": "",
          "name": "Instagram",
          "icon": "assets/images/insta.svg"
      },
      {
          "className": "text-uppercase",
          "link": "https://twitter.com/airtelmlw",
          "target": "",
          "name": "Twitter",
          "icon": "assets/images/twitter.svg"
      },
      {
          "className": "text-uppercase",
          "link": "https://www.facebook.com/airtelmw",
          "target": "",
          "name": "Facebook",
          "icon": "assets/images/fb.svg"
      }
  ]
}
      
        
     



export default FOOTER_DATA;